var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileCleaningImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#e7e6e6;}.c{fill:#8c94c9;}.d{fill:#97d3f1;}.e{opacity:0.995;}.f{fill:#007da0;}.g{fill:#0fb4d1;}.h{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.373 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 -21)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(56.15 88.221)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(47.443 36.88)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(42.611 64.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22 -14)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(81.357 79.38)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(89.932 47.762)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(62.533 16.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-123.807 83.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 -139.709)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M125.577,80a1.57,1.57,0,0,1,.735,1.511c-.04,1.439-.012,2.88-.012,4.373.656-.207,1.362-.423,1.725.3a1.491,1.491,0,0,1-.059,1.249c-.384.612-1.031.435-1.665.185,0,2.113,0,4.2,0,6.286,0,1.192-.335,1.52-1.547,1.52h-9.994c.2.657.414,1.359-.313,1.711a1.5,1.5,0,0,1-1.243-.069c-.57-.358-.491-.976-.145-1.641-.876,0-1.677-.033-2.473.01A1.568,1.568,0,0,1,109,94.7V80Zm-14.357,2.187v7.232h12.857V82.188Zm.009,9.5v1.506H124.1V91.685Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M203.76,202.557a1.526,1.526,0,0,1-.735-1.506c.04-1.437.012-2.876.012-4.377-.678.217-1.4.405-1.758-.349a1.476,1.476,0,0,1,.123-1.244c.383-.554,1.007-.4,1.635-.129v-4.189q0-1.044,0-2.087c0-1.216.321-1.544,1.517-1.544q4.641,0,9.282,0h.753c-.224-.654-.418-1.321.265-1.694a1.436,1.436,0,0,1,1.188-.012c.664.367.568,1.022.259,1.706.895,0,1.726.027,2.555-.008a1.35,1.35,0,0,1,1.479.875v14.559Zm1.473-6H218.1v-7.2h-12.87Zm12.9,2.278h-12.87v1.514h12.87Z",
    transform: "translate(-78.904 -90.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M137.421,229.48a1.052,1.052,0,0,1-1.064,1.1,1.1,1.1,0,0,1-1.091-1.165,1.122,1.122,0,0,1,1.087-1.1A1.072,1.072,0,0,1,137.421,229.48Z",
    transform: "translate(-22.479 -126.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M294.936,142.068a1.13,1.13,0,0,1-1.11,1.156,1.069,1.069,0,0,1-1.045-1.125,1.055,1.055,0,0,1,1.014-1.146A1.1,1.1,0,0,1,294.936,142.068Z",
    transform: "translate(-157.289 -52.166)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M271.611,119.393a1.065,1.065,0,0,1,1.1,1.139,1.046,1.046,0,0,1-1.138,1.018,1.059,1.059,0,0,1-1.113-1.124A1.094,1.094,0,0,1,271.611,119.393Z",
    transform: "translate(-138.187 -33.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M293.822,162.907a1.07,1.07,0,0,1,1.1,1.146,1.113,1.113,0,0,1-1.082,1.106,1.128,1.128,0,0,1-.015-2.252Z",
    transform: "translate(-157.272 -70.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M135.261,207.557a1.1,1.1,0,0,1,1.141-1.038,1.125,1.125,0,0,1-.179,2.242A1.092,1.092,0,0,1,135.261,207.557Z",
    transform: "translate(-22.473 -108.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M159.157,251.741a1.1,1.1,0,0,1-1.122,1.078,1.08,1.08,0,0,1-1.13-1.132,1.129,1.129,0,0,1,2.251.054Z",
    transform: "translate(-41 -146.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M181.012,251.753a1.115,1.115,0,0,1-2.229-.083,1.026,1.026,0,0,1,1.158-1A1,1,0,0,1,181.012,251.753Z",
    transform: "translate(-59.723 -146.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M250.974,120.523a1.038,1.038,0,0,1-1.176,1.047,1,1,0,0,1-1.053-1.091,1.115,1.115,0,0,1,2.229.044Z",
    transform: "translate(-119.601 -33.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M293.344,121.758a1.221,1.221,0,0,1-1.136-1.171,1.121,1.121,0,0,1,2.238.064A1.13,1.13,0,0,1,293.344,121.758Z",
    transform: "translate(-156.798 -33.848)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M137.5,251.287a1.121,1.121,0,0,1-2.238-.072,1.137,1.137,0,0,1,1.106-1.105A1.227,1.227,0,0,1,137.5,251.287Z",
    transform: "translate(-22.477 -145.588)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCleaningImage);
export default __webpack_public_path__ + "static/media/fileCleaningImage.c4908cec21f2188e8660512103db79b8.svg";
export { ForwardRef as ReactComponent };